import React from 'react';
import { UsersIcon, CalendarIcon, TrendingUpIcon, AwardIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function SocialProofSection() {
  const {
    t
  } = useLanguage();
  const stats = [{
    icon: UsersIcon,
    value: '110+',
    label: t('social.customers'),
    description: t('social.customers.desc')
  }, {
    icon: CalendarIcon,
    value: '4+',
    label: t('social.experience'),
    description: t('social.experience.desc')
  }, {
    icon: TrendingUpIcon,
    value: '€7M+',
    label: t('social.revenue'),
    description: t('social.revenue.desc')
  }, {
    icon: AwardIcon,
    value: '98%',
    label: t('social.satisfaction'),
    description: t('social.satisfaction.desc')
  }];
  return <section className="py-12 lg:py-16 bg-[#0a0e1a] border-y border-white/5" data-id="element-239">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-241">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-242">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-[#ff6b35]/10 rounded-lg mb-4" data-id="element-243">
                <stat.icon className="w-6 h-6 text-[#ff6b35]" data-id="element-244" />
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2" data-id="element-245">
                {stat.value}
              </div>
              <div className="text-base font-semibold text-gray-300 mb-1" data-id="element-246">
                {stat.label}
              </div>
              <div className="text-sm text-gray-500" data-id="element-247">{stat.description}</div>
            </div>)}
        </div>
      </div>
    </section>;
}